import theme from '../../styles/theme';
export const sizes = {
    medium: 'medium',
    small: 'small',
};
export const styles = {
    dark: 'dark',
    light: 'light',
};
export const types = {
    determinate: 'determinate',
    indeterminate: 'indeterminate',
};
export const containerSizes = {
    [sizes.medium]: 48,
    [sizes.small]: 32,
};
export const baseVariations = {
    dark: {
        strokeBackgroundColor: theme.colors.accent400,
        strokeColor: theme.colors.accent700,
        textColor: theme.colors.accent800,
    },
    light: {
        strokeBackgroundColor: theme.colors.accent600,
        strokeColor: theme.colors.gray100,
        textColor: theme.colors.gray100,
    },
};
